<template>
	<v-card>
		<v-card-text>
			<params-component
				:items="items"
				:filters="filters"
				:filtersSelected="filtersSelected"
				:updateFilters="updateFilters"
				:weight="weight"
				:weightSelected="weightSelected"
				:updateWeight="updateWeight"
			></params-component>
			<table-component
				:headers="items"
				:rows="rows"
				:deleteRow="deleteRow"
				:copyRow="copyRow"
				:importance="importance"
				:categories="items"
				:rowsValue="rowsValue"
				:saveRowChanges="saveRowChanges"
				:paramsValue="paramsValue"
				:addRow="addRow"
			></table-component>
			<br/>
			<span v-if="baseSize">
				База: {{baseSize}}
			</span>
			<br v-if="sumWeight"/>
			<span v-if="sumWeight">
				Взвешенная база: {{sumWeight}}
			</span>
			<br/>
			<v-switch
				v-if="hasNoneRow && rowsValue.length"
				v-model="noneRowInner"
				label="Строка none"
			></v-switch>
			<v-btn text @click="saveToExcel" v-if="rowsValue.length">
				<v-icon color="green">mdi-file-excel</v-icon>
				Сохранить в Excel
			</v-btn>
		</v-card-text>
	</v-card>
</template>

<script>
  import {ParamsComponent, TableComponent} from './'

  export default {
    name: "EditConcept",
    props: {
      items: Array,
      filters: Array,
      filtersSelected: Array,
      updateFilters: Function,
      weight: Array,
      weightSelected: String,
      updateWeight: Function,
      rows: Array,
      importance: Object,
      rowsValue: Array,
      saveRowChanges: Function,
      paramsValue: Object,
      addRow: Function,
      baseSize: Number,
      sumWeight: String,
      updateData: Function,
      hasNoneRow: Boolean,
      noneRow: Boolean,
      saveToExcel: Function,
      deleteRow: Function,
      copyRow: Function,
      toggleNoneRow: Function,
    },
    components: {
      ParamsComponent,
      TableComponent,
    },
    computed: {
      noneRowInner: {
        get: function () {
          return this.noneRow
        },
        set: function () {
          this.toggleNoneRow()
        },
      }
    },
  }
</script>